import { getRawToken } from "@kinde-oss/kinde-auth-react/utils";
import { IAuthProvider } from "@next-platform/client-common-core";

import { GUEST_USER_ID_KEY, JWT_LOCAL_STORAGE_KEY } from "@/constants";
import { getIsPartner } from "@/utils/getIsPartner";

export class AuthProvider implements IAuthProvider {
  async getToken(): Promise<string> {
    const isPartner = getIsPartner();
    if (isPartner) {
      const token = import.meta.env.MODE.includes("production")
        ? sessionStorage.getItem(JWT_LOCAL_STORAGE_KEY)
        : localStorage.getItem(JWT_LOCAL_STORAGE_KEY);
      return Promise.resolve(token ?? "");
    } else {
      return (await getRawToken()) ?? "";
    }
  }
  getGuestUserId(): string {
    return localStorage.getItem(GUEST_USER_ID_KEY) ?? "";
  }
}
